import type { WhatsAppTranslations } from '../interfaces/whatsapp';

export const whatsAppTranslations: WhatsAppTranslations = {
  chatTitle: 'Chat',

  integrationSectionTitle: 'WhatsApp Business',
  integrationSectionDescription:
    'Conecte sua conta do WhatsApp Business para que seu agente receba e responda mensagens em seu nome.',
  connectCardTitle: 'Conecte seu WhatsApp Business',
  connectCardDescription:
    'Vamos redirecioná-lo à Meta para autorizar a conexão, escolher seu número e conceder as permissões. Você controla o que é autorizado.',
  connectButton: 'Conectar meu WhatsApp Business',
  connectingLabel: 'Conectando…',
  connectedBadge: 'Conectado',
  connectedAtLabel: 'Conectado em',
  verifiedNameLabel: 'Nome verificado',
  phoneNumberLabel: 'Número',
  businessIdLabel: 'ID do portfólio de negócios',
  businessIdMissing: 'Indisponível — reconecte para gerenciar modelos',
  wabaIdLabel: 'WABA ID',
  phoneNumberIdLabel: 'Phone Number ID',
  technicalDetailsLabel: 'Detalhes técnicos',
  reconnectButton: 'Reconectar com outra conta',
  syncPhonesButton: 'Sincronizar números',
  syncPhonesSuccess: 'Números sincronizados',
  syncPhonesError: 'Não foi possível sincronizar os números',
  reconnectDialogTitle: 'Reconectar seu WhatsApp Business?',
  reconnectDialogDescription:
    'Isso substituirá a conexão atual pela nova conta que você escolher na Meta.',
  reconnectDialogConfirm: 'Sim, reconectar',
  reconnectDialogCancel: 'Cancelar',
  switchToManualButton: 'Mudar para token de acesso',
  disconnectButton: 'Desconectar',
  disconnectDialogTitle: 'Desconectar o WhatsApp Business?',
  disconnectDialogDescription:
    'Seu agente deixará de receber e responder mensagens neste número. Você pode conectá-lo novamente quando quiser, com o Facebook ou com um token de acesso.',
  disconnectDialogConfirm: 'Sim, desconectar',
  disconnectDialogCancel: 'Cancelar',
  disconnectSuccess: 'WhatsApp desconectado.',
  disconnectError: 'Não foi possível desconectar seu WhatsApp. Tente novamente.',
  sdkLoadError:
    'Não foi possível carregar o SDK do Facebook. Desative seu adblocker ou verifique sua conexão.',
  cancelledMessage: 'Você fechou o diálogo da Meta antes de terminar.',
  successToast: 'WhatsApp conectado com sucesso!',
  errorStepExchangeCode:
    'O processo expirou. Inicie a conexão novamente do zero.',
  errorStepDebugToken:
    'Não foi possível validar sua conta do WhatsApp Business. Verifique se ela está configurada corretamente na Meta.',
  errorStepVerifyToken:
    'O token que você colou não está autorizado para essa conta do WhatsApp Business. Verifique o WABA ID e as permissões do token.',
  errorStepPhoneNumbers:
    'Sua conta do WhatsApp Business não possui um número de telefone. Cadastre um no Meta Business Suite e tente novamente.',
  errorStepSubscribeApps:
    'Não foi possível assinar suas mensagens do WhatsApp. Se outra plataforma estiver conectada, desconecte-a primeiro.',
  errorStepPersist: 'Erro ao salvar sua conexão. Tente novamente em instantes.',
  errorStatusLoad:
    'Não foi possível carregar o status da sua conexão. Tente novamente.',
  errorUnknown: 'Ocorreu um erro inesperado. Tente novamente.',
  retryButton: 'Tentar novamente',
  redirectDisclaimer:
    'Vamos redirecioná-lo à Meta para autorizar. Você controla as permissões.',

  configureButton: 'Configurar canal',
  tilePhonesCount: '{{count}} número',
  drawerTitle: 'WhatsApp Business · canal',
  drawerDescription:
    'Detalhes de conexão, agente padrão e vínculos por número.',

  manualConnectLink: 'Conectar com credenciais',
  manualDrawerTitle: 'Conectar com credenciais',
  manualDrawerDescription:
    'Já tem um token de System User do Meta Business Manager? Cole-o aqui junto com seu WABA ID e validaremos e registraremos sua conta.',
  manualAccessTokenLabel: 'Token de acesso',
  manualAccessTokenPlaceholder: 'EAAGm0PX...',
  manualAccessTokenHelp:
    'Token de System User de longa duração com as permissões whatsapp_business_management e whatsapp_business_messaging.',
  manualWabaIdLabel: 'ID da conta do WhatsApp Business',
  manualWabaIdPlaceholder: '102290129340398',
  manualWabaIdHelp:
    'ID numérico do WABA para o qual o token está autorizado. Você o encontra no Meta Business Manager.',
  manualBusinessIdLabel: 'ID do portfólio de negócios (opcional)',
  manualBusinessIdPlaceholder: '1174430681268289',
  manualBusinessIdHelp: 'Está em Configurações do negócio → Informações do negócio. Sem ele você não poderá criar nem sincronizar modelos.',
  manualBusinessIdInvalid: 'O ID só pode conter números',
  manualSubmit: 'Conectar',
  manualReplaceSubmit: 'Substituir conexão',
  manualReplaceWarningTitle: 'Você já tem uma conta conectada',
  manualReplaceWarningDescription:
    'Ao continuar, você substituirá a conexão atual (WABA {{wabaId}}) pela que estas credenciais autorizarem.',
  manualSuccess: 'WhatsApp conectado com sucesso!',
  manualAccessTokenRequired: 'Cole seu token de acesso para continuar.',
  manualWabaIdRequired: 'Informe seu WABA ID para continuar.',
  manualWabaIdInvalid: 'O WABA ID deve ser numérico.',

  manualGuideTitle: 'Como obter essas credenciais',
  manualGuideStep1:
    'Abra o Meta Business Manager e escolha o negócio dono da sua conta do WhatsApp.',
  manualGuideStep1Link: 'Abrir Business Manager',
  manualGuideStep2:
    'Em Configurações do negócio → Contas → Contas do WhatsApp, selecione seu WABA e copie o ID (visível na URL e no painel lateral).',
  manualGuideStep2Link: 'Abrir Contas do WhatsApp',
  manualGuideStep3:
    'Em Configurações do negócio → Usuários → Usuários do sistema, crie ou escolha um System User, clique em "Gerar novo token", selecione seu app da Meta e as permissões abaixo, e copie o token.',
  manualGuideStep3Link: 'Abrir Usuários do sistema',
  manualGuideScopes:
    'Permissões necessárias do token: whatsapp_business_management e whatsapp_business_messaging.',
  manualGuideDocsLink: 'Ler o guia oficial da Meta',
};
